"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ar = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
// prettier-ignore
// eslint-disable-next-line
exports.ar = {
    locale: 'ar',
    // 操作：确定按钮
    okText: ('موافق'),
    // 操作：取消按钮
    cancelText: ('إلغاء'),
    // 文案：数据加载中
    loadingText: ('جارٍ التحميل…'),
    // 文案：数据加载失败
    loadErrorText: ('فشل التحميل'),
    // 操作：重试数据加载
    loadRetryText: ('إعادة المحاولة'),
    // 操作：关闭
    closeText: ('إغلاق'),
    // 文案：帮助
    helpText: ('مساعدة'),
    // 操作：清空
    cleanText: ('مسح'),
    // 操作：搜索
    searchText: ('بحث'),
    // 文案：数据为空
    emptyText: ('لا تتوفر بيانات بعد'),
    // 操作：全选
    selectAllText: ('تحديد الكل'),
    // 文案：分页组件显示总记录数
    paginationRecordCount: function (count) { return (react_1.default.createElement(react_1.Fragment, null,
        "\u0625\u062C\u0645\u0627\u0644\u064A \u0639\u062F\u062F \u0627\u0644\u0639\u0646\u0627\u0635\u0631: ",
        react_1.default.createElement("strong", null, count))); },
    // 操作：跳到上一页
    paginationPrevPage: ('السابق'),
    // 操作：跳到下一页
    paginationNextPage: ('التالي'),
    // 操作：跳到第一页
    paginationToFirstPage: ('الصفحة الأولى'),
    // 操作：跳到最后一页
    paginationToLastPage: ('الصفحة الأخيرة'),
    // 文案：提醒用户当前已经在第一页，无法再跳到上一页
    paginationAtFirst: ('هذه هي الصفحة الأولى'),
    // 文案：提醒用户当前已经在最后一页，无法再跳到上一页
    paginationAtLast: ('هذه هي الصفحة الأخيرة'),
    // 文案：表示分页组件每页显示多少行记录，后接行数选项
    paginationRecordPerPage: ('/ الصفحة'),
    // 文案：表示分页组件总共有多少页，前面是当前的页码
    paginationPageCount: function (count) { return (" / " + count + " \u0635\u0641\u062D\u0627\u062A"); },
    // 文案：下拉选择组件默认的提示文案
    pleaseSelect: ('يرجى التحديد'),
    // 文案：查询到结果
    foundText: ('تم العثور على النتائج التالية'),
    // 文案：表格中，用于显示找到多少条结果，后面会拼接「返回原列表」
    foundManyText: function (count) { return (count + " \u0646\u062A\u0627\u0626\u062C \u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u064A\u0647\u0627"); },
    // 文案：同 resultText，不过是在有关键字的情况下显示
    foundManyTextWithKeyword: function (keyword, count) { return (count + " \u0646\u062A\u0627\u0626\u062C \u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u064A\u0647\u0627 \u0644\u0640 \u201C" + keyword + "\u201D"); },
    // 文案：搜索某个关键字的情况下，没有找到结果
    foundNothingWithKeyword: function (keyword) { return ("\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0646\u062A\u0627\u0626\u062C \u0644\u0640 \u201C" + keyword + "\u201D"); },
    // 操作：表格中清空当前筛选结果，返回源列表
    clearResultText: ('الرجوع إلى القائمة'),
    // 文案：tagSearchBox 使用提示
    tagSearchBoxTips: ('كلمات أساسية بها ”|“; اضغط على Enter لفصل علامات التصفية'),
    // 文案：tagSearchBox 使用提示
    tagSearchBoxEditingTips: ('انقر للتعديل. واضغط على Enter للإنهاء.'),
    // 文案：tagSearchBox 选择框标题
    tagSearchBoxSelectTitle: ('تحديد عامل تصفية'),
    // 文案：tagSearchBox 帮助图片地址
    tagSearchBoxHelpImgUrl: ('//imgcache.qq.com/open_proj/proj_qcloud_v2/mc_2014/server/css/img/search-dialog-en.png'),
    // 文案：今天
    today: ('اليوم'),
    // 文案：本月
    curMonth: ('هذا الشهر'),
    // 文案：下个月
    prevMonth: ('الشهر السابق'),
    // 文案：下个月
    nextMonth: ('الشهر التالي'),
    // 文案：今年
    curYear: ('هذا العام'),
    // 文案：下一年
    prevYear: ('العام السابق'),
    // 文案：下一年
    nextYear: ('العام التالي'),
    // 文案：当前二十年
    curTwentyYears: ('هذا العام'),
    // 文案：上二十年
    prevTwentyYears: ('20 عامًا سابقة'),
    // 文案：下二十年
    nextTwentyYears: ('20 عامًا تالية'),
    // 变量：该语言日期表达中 [月] 是否在 [年] 之前，是的话为 - true，否则 - false
    monthBeforeYear: (true),
    // 变量：该语言日期表达中 [年] 的表达方式，其中 YYYY 为年份数字
    yearFormat: ('YYYY '),
    // 文案：选择时间
    selectTime: ('تحديد الوقت'),
    // 文案：开始时间
    startTime: ('وقت البدء'),
    // 文案：结束时间
    endTime: ('وقت الانتهاء'),
    // 文案：选择日期
    selectDate: ('تحديد التاريخ'),
    // 文案：跳过
    guideCancel: ('تخطٍ'),
    // 文案：上一步
    guideBack: ('رجوع'),
    // 文案：下一步
    guideNext: ('التالي'),
    // 文案：完成
    guideFinish: ('تم'),
    // 文案：复制
    copy: ('نسخ'),
    // 文案：复制成功
    copied: ('تم النسخ'),
    // 文案：点击查看大图
    clickToEnlarge: ('انقر للتكبير'),
    // 文案：展开
    expand: ('توسيع'),
    // 文案：收起
    collapse: ('طي'),
};
